module.exports = __webpack_public_path__ + "static/media/page12_mum_kids.6e6bb64c.png";